import { useEffect } from "react";
import { handleSilentRenew } from "./oidc";

export function SilentRenew() {
  useEffect(() => {
    void handleSilentRenew().catch(() => {});
  }, []);

  return <div />;
}
